<!--
 @description 全网拓扑
 @date 2018/11/16
-->
<template>
  <div class="topo-edit-wrap networkTopology__content">
    <!-- 工具栏 --> 
    <div class="tool-wrap" :class="{ 'tool-wrap-active' : showTools }">
      <div id="toolbar" class="ilb" v-show="showTools">
        <i
          data-command="autoZoom"
          class="command iconfont icon-shiyinghuabu"
          :title="$t('networkTopology.fit')"></i>
        <i
          data-command="multiSelect"
          class="command iconfont icon-pingtaitubiao_duoxuan"
          :title="$t('networkTopology.multiSelect')"></i>
        <i
          data-command="customAddGroup"
          class="command iconfont icon-chengzu"
          :title="$t('networkTopology.addGroup')"></i>
      </div>
      <i
        v-show="showTools"
        @click="savePage"
        class="handle-command iconfont icon-baocun"
        style="margin-right: 10px;"
        :title="$t('networkTopology.save')"></i>
      <i
        @click="showTools = !showTools"
        class="handle-command handle-command-ver iconfont icon-guding-xian"
        :class="{ 'handle-command-active' : showTools }"
        v-g-rac="gRac('networkTopology_save')"
        :title="$t('networkTopology.showTools')"></i>
    </div>
    <div style="position: relative;">
      <!-- 左侧节点栏 -->
      <transition name="fade">
        <div id="itempannel" v-show="showTools">
          <div class="itempannel-title" v-text="$t('networkTopology.component')"></div>
          <img
            v-for="(item, index) in arrowList"
            draggable="false"
            :src="item.img"
            data-type="node"
            :data-shape="item.name"
            :key="item.name"
            :data-size="index < 3 ? '40*70' : '70*40'"
            data-color="#00ffff"
            class="getItem arrow-ver"
            :class="{'arrow-hor' : index >= 3 }">
          <div 
            class="getItem line-item line-item-ver"
            data-size="40*70"
            draggable="false"
            data-shape="line_ver"
            data-color="#9c9c9c"
            data-type="node">
            <div class="line-hor"></div>
          </div>
          <div 
            class="getItem line-item"
            data-size="70*40"
            draggable="false"
            data-shape="line_hor"
            data-color="#9c9c9c"
            data-type="node">
            <div class="line-hor"></div>
          </div>
          <div
            class="getItem text-item"
            data-size="80*26"
            draggable="false"
            data-color="#000"
            data-shape="custom_text"
            :data-label="$t('networkTopology.textInput')"
            data-type="node"><div v-text="$t('networkTopology.textInput')"></div></div>
          <div
            class="getItem app-node-wrap"
            draggable="false"
            data-size="70*40"
            data-color="#2ec100"
            data-shape="flow-rect"
            :data-label="$t('networkTopology.customNode')"
            data-type="node"><div class="app-node" v-text="$t('networkTopology.customNode')"></div></div>
          <div class="itempannel-title" v-text="$t('networkTopology.element')"></div>
          <div :style="appWrapStyle">
            <el-input 
              class="itempannel-input mt10" 
              v-model="searchNodeName" 
              :placeholder="$t('networkTopology.searchPlaceHolder')"></el-input>
            <div
              v-for="item in appList"
              class="getItem app-node-wrap"
              draggable="false"
              data-size="70*40"
              data-color="#2ec100"
              data-shape="flow-rect"
              :key="item"
              :data-label="item"
              data-type="node"><div class="app-node" v-text="item"></div>
            </div>
          </div>
        </div>
      </transition>
      <!-- 画布 -->
      <div id="page"></div>
      <!-- 右键 -->
      <div v-show="showTools">
        <div id="contextmenu">
          <div
            data-status="node-selected"
            class="menu">
            <div
              data-command="delete"
              class="command">
              <span v-text="$t('networkTopology.delete')"></span>
              <span>delete</span>
            </div>
          </div>
          <div
            data-status="edge-selected"
            class="menu">
            <div
              data-command="delete"
              class="command">
              <span v-text="$t('networkTopology.delete')"></span>
              <span>delete</span>
            </div>
          </div>
          <div
            data-status="group-selected"
            class="menu">
            <div
              data-command="delete"
              class="command">
              <span v-text="$t('networkTopology.delete')"></span>
              <span>delete</span>
            </div>
            <div
              data-command="unGroup"
              class="command">
              <span v-text="$t('networkTopology.unGroup')"></span>
              <span>unGroup</span>
            </div>
          </div>
        </div>
      </div>
      <!-- 详情 -->
      <transition name="fade">
        <div id="detailpannel" v-show="showTools">
          <!-- 节点详情 -->
          <div
            id="node_detailpannel"
            data-status="node-selected"
            class="pannel">
            <div class="itempannel-title" v-text="$t('networkTopology.node')"></div>
            <div class="block-container">
              <div v-show="currentShape === 'text' || currentShape === 'element'" class="pannel-item">
                <span v-text="$t('networkTopology.name')"></span>：
                <el-input class="pannel-input" v-model="nodeName"></el-input>
              </div>
              <div v-show="currentShape === 'arrow' || currentShape === 'element'" class="pannel-item">
                <span v-text="$t('networkTopology.size')"></span>：
                <el-input class="pannel-input pannel-input-min" v-model="nodeWidth"></el-input>
                <el-input class="pannel-input pannel-input-min" v-model="nodeHeight"></el-input>
              </div>
              <div v-show="currentShape === 'text'" class="pannel-item">
                <span v-text="$t('networkTopology.size')"></span>：
                <el-input class="pannel-input" v-model="nodeFontSize"></el-input>
              </div>
              <div v-show="currentShape === 'line'" class="pannel-item">
                <span v-text="$t('networkTopology.length')"></span>：
                <el-input class="pannel-input" v-model="nodeLength"></el-input>
              </div>
              <div v-show="currentShape === 'element'" class="pannel-item">
                <span v-text="$t('networkTopology.link')"></span>：
                <el-select 
                  v-model="chooseLink" 
                  @focus="getPinpoints"
                  filterable clearable 
                  :placeholder="$t('common.chooseTips')"
                  class="pannel-input">
                  <el-option
                    v-for="item in pinPoints"
                    :key="item.value"
                    :label="item.label"
                    :value="item.value">
                  </el-option>
                </el-select>
              </div>
              <el-button type="primary" @click="updateNode" v-text="$t('networkTopology.update')"></el-button>
            </div>
          </div>
          <!-- 组详情 -->
          <div
            id="group_detailpannel"
            data-status="group-selected"
            class="pannel">
              <div class="itempannel-title" v-text="$t('networkTopology.group')"></div>
              <div class="block-container">
                <div class="pannel-item">
                  <span v-text="$t('networkTopology.lineWidth')"></span>：
                  <el-input class="pannel-input" v-model="groupLineWidth"></el-input>
                </div>
                <div class="pannel-item">
                  <div style="display: inline-block; position: relative; top: 50%; transform: translateY(-50%)">
                    <span v-text="$t('networkTopology.color')"></span>：
                  </div>
                  <el-color-picker v-model="groupLineColor" size="small"></el-color-picker>
                </div>
                <el-button type="primary" @click="updateGroup" v-text="$t('networkTopology.update')"></el-button>
            </div>
          </div>
          <!-- 画布详情 -->
          <div
            id="canvas_detailpannel"
            data-status="canvas-selected"
            class="pannel">
            <div class="itempannel-title pannel-title" v-text="$t('networkTopology.page')"></div>
            <div class="block-container">
              <el-checkbox v-model="showGrid">{{ $t('networkTopology.grid') }}</el-checkbox>
              <div id="slider"></div>
            </div>
          </div>
        </div>
      </transition>
      <!-- 导航器 -->
      <transition name="fade">
        <div id="navigator" v-show="showTools">
          <div class="itempannel-title" v-text="$t('networkTopology.navigator')"></div>
          <div id="minimap"></div>
          <div class="slider-wrap">
            <el-slider
              v-model="curZoom"
              :min="0.5"
              :max="2"
              :step="0.01"
              :format-tooltip="formatTooltip"></el-slider>
          </div>
        </div>
      </transition>
    </div>
  </div>
</template>

<script>
  import rac from '@/plugins/rac-mixin'
  import Editor from '@/views/component/networkTopology/editor.vue'
  import appManagerBiz from '@/logic/cmdb/appManagerBiz'
  import networkTopologyBiz from '@/logic/intelligentMonitor/networkTopologyBiz'
  const GET_STATISTICS_TIME = 1000 * 60
  export default {
    extends: Editor,
    mixins: [rac],
    data () {
      return {
        chooseLink: '',
        showGrid: false,
        nodeList: [],
        appList: [],
        primaryAppList: [],
        nodeWidth: '',
        nodeHeight: '',
        nodeName: '',
        nodeLength: 70,
        nodeFontSize: 20,
        groupLineWidth: '1',
        groupLineColor: '#dedede',
        searchNodeName: '',
        currentShape: '',
        appWrapStyle: {
          height: 0,
          'overflow-y': 'scroll'
        },
        searchTimer: null,
        searchPinpointTimer: null,
        showTools: false,
        pinPointsList: [],
        pinPoints: {},
        topoInfo: {},
        topoTimer: null
      }
    },
    components: {},
    methods: {
      saveTopoInfo (saveInfo) {
        networkTopologyBiz.saveNewTopology(saveInfo).then(d => {
          this.$message({
            message: this.$t('common.success'),
            type: 'success'
          })
          this.showTools = false
        })
      },
      getTopoInfo () {
        networkTopologyBiz.getNewTopology().then(data => {
          if (data) {
            this.topoInfo = data
            if (this.showTools) {
              this.clearTopoTimer()
              this.page.read(data)
            } else {
              this.getStatistics()
              this.setTopoTimer()
            }
          }
        })
      },
      getStatistics () {
        networkTopologyBiz.getAlarmStatistics().then(data => {
          let statusArr = data
          if (this.topoInfo.nodes && this.topoInfo.nodes.length > 0) {
            this.topoInfo.nodes.map((item) => {
              statusArr.map((_item) => {
                if (item.label && item.label === _item.group) {
                  // 告警红色
                  let statusList = ['1', '2', '3', '4']
                  if (_item.maxLevel in statusList) {
                    item.color = '#FF0000'
                  }
                }
              })
            })
            this.page.read(this.topoInfo)
          }
        })
      },
      getGroups () {
        appManagerBiz.queryGroups().then((data) => {
          this.appList = data
          this.primaryAppList = data
        })
      },
      getPinpoints () {
        appManagerBiz.getPinpoints().then((data) => {
          this.pinPointsList = data.dataList
          let pinPoints = []
          data.dataList.map(item => {
            pinPoints.push({ value: item.appName, label: item.appName })
          })
          this.pinPoints = pinPoints
        })
      },
      clearTopoTimer () {
        clearTimeout(this.topoTimer)
        this.topoTimer = null
      },
      setTopoTimer () {
        this.clearTopoTimer()
        this.topoTimer = setTimeout(() => {
          this.getStatistics()
          this.setTopoTimer()
        }, GET_STATISTICS_TIME)
      },
      updateNode () {
        let updateObj = {}
        if (this.currentShape === 'arrow') {
          updateObj.size = `${this.nodeWidth}*${this.nodeHeight}`
        } else if (this.currentShape === 'text') {
          updateObj.label = this.nodeName
          updateObj.fontSize = this.nodeFontSize
        } else if (this.currentShape === 'element') {
          updateObj.label = this.nodeName
          updateObj.size = `${this.nodeWidth}*${this.nodeHeight}`
          if (this.chooseLink && this.chooseLink !== this.$t('networkTopology.choose')) {
            updateObj.appName = this.chooseLink
            updateObj.url = this.pinPointsList.filter(item => item.appName === this.chooseLink)[0].uri
          } else {
            updateObj.url = ''
            updateObj.appName = ''
          }
        } else if (this.currentShape === 'line') {
          if (this.selectedModel.shape.indexOf('hor') >= 0) {
            updateObj.size = `${this.nodeLength}*40`
          } else {
            updateObj.size = `40*${this.nodeLength}`
          }
        }
        this.page.update(this.selectedModel.id, { ...updateObj })
      },
      updateGroup () {
        let updateObj = {
          lineWidth: this.groupLineWidth,
          color: this.groupLineColor
        }
        this.page.update(this.selectedModel.id, { ...updateObj })
      },
      formatTooltip (value) {
        return `${(value * 100).toFixed(0)}%`
      },
      getFormatTime () {
        let date = new Date()
        let month = date.getMonth() + 1 <= 9 ? `0${date.getMonth() + 1}` : date.getMonth() + 1
        let hour = date.getHours() <= 9 ? `0${date.getHours()}` : date.getHours()
        let second = date.getSeconds() <= 9 ? `0${date.getSeconds()}` : date.getSeconds()
        let minute = date.getMinutes() <= 9 ? `0${date.getMinutes()}` : date.getMinutes()
        let year = date.getFullYear()
        let day = date.getDate() <= 9 ? `0${date.getDate()}` : date.getDate()
        return `${year}-${month}-${day}-${hour}-${minute}-${second}`
      }
    },
    watch: {
      $route (to, from) {
        if (from.name === 'networkTopology') {
          this.clearTopoTimer()
        } else if (to.name === 'networkTopology') {
          this.getGroups()
          if (!this.showTools && this.topoInfo.nodes) {
            this.getStatistics()
            this.setTopoTimer()
          }
        }
      },
      showGrid (val) {
        if (val) {
          this.page.showGrid()
        } else {
          this.page.hideGrid()
        }
      },
      searchNodeName (val) {
        clearTimeout(this.searchTimer)
        this.searchTimer = null
        this.searchTimer = setTimeout(() => {
          this.appList = this.primaryAppList.filter(item => {
            return (item.toLowerCase()).indexOf(val.toLowerCase()) >= 0
          })
        }, 1000)
      },
      showTools (val) {
        this.getTopoInfo()
        this.editor.destroy()
        if (val) {
          this.initEditor(true)
        } else {
          this.initEditor(false)
        }
        if (val && !this.appWrapStyle.height) {
          this.$nextTick(() => {
            this.appWrapStyle.height = document.getElementById('itempannel').offsetHeight - 384 + 'px'
          })
        }
      },
      curZoom (val) {
        this.changeZoom(val)
      }
    },
    mounted () {
      this.initEditor()
      this.getGroups()
      this.getTopoInfo()
    }
  }
</script>

<style>
  .tool-wrap {
    position: absolute;
    z-index: 10;
    transition: right .6s;
    top: 26px;
    right: 30px;
  }
  .tool-wrap-active {
    right: 230px;
  }
  .handle-command {
    display: inline-block;
    height: 25px;
    line-height: 28px;
    cursor: pointer;
    opacity: .5;
    transition: all .3s;
    font-size: 18px;
    cursor: pointer;
  }
  .handle-command-ver {
    transform: rotateZ(90deg);
  }
  .handle-command-active {
    transform: rotateZ(135deg);
  }
  .handle-command:hover {
    color: #3385ff;
    opacity: 1;
  }
  .topo-edit-wrap {
    user-select: none;
    -moz-user-select: none;
    -webkit-user-select: none;
    -ms-user-select: none;
  }
  .app-node-wrap {
    width: 70px;
    height: 40px;
    margin: 4px 0 0 4px;
    padding: 4px;
    border-radius: 2px;
    border: 1px solid rgba(0,0,0,0);
    display: inline-block;
    position: relative;
  }
  .app-node-wrap:hover {
    cursor: move;
    border: 1px solid #ccc;
  }
  .app-node {
    color: #737373;
    width: 70px;
    height: 40px;
    line-height: 40px;
    font-size: 12px;
    position: absolute;
    top: 50%;
    left: 50%;
    transform: translate(-50%, -50%);
    background: #ecffe6;
    text-align: center;
    border: 2px solid #96F11A;
    border-radius: 6px;
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
    cursor: move;
  }
  .topo-edit-wrap .choose-btn {
    cursor: pointer;
    color: #3385ff;
  }
  .itempannel-input {
    width: 156px;
    margin-top: 4px;
    margin-left: 8px;
  }
  .itempannel-title {
    border-top: 1px solid #ddd;
    border-bottom: 1px solid #ddd;
    padding: 4;
    padding: 4px;
    background: #f5f5f5;
    font-size: 14px;
    text-align: center;
  }
  .pannel-title {
    border-top: none;
  }
  #itempannel {
    width: 190px;
    height: 100%;
    position: absolute;
    top: 0;
    left: 0;
    border: 1px solid #ddd;
    border-top: none;
    z-index: 9;
    background: #fff;
    box-sizing:border-box;
    -moz-box-sizing:border-box; /* Firefox */
    -webkit-box-sizing:border-box; /* Safari */
  }
  #itempannel img {
    padding: 4px;
    margin-left: 4px;
    border-radius: 2px;
    border: 1px solid rgba(0,0,0,0);
  }
  #itempannel img:hover {
    cursor: move;
    border: 1px solid #ccc;
  }
  #itempannel .arrow-ver {
    width: 40px;
    height: 70px;
  }
  #itempannel .arrow-hor {
    width: 70px;
    height: 40px;
  }
  #page{
    border: 1px solid #ddd;
    background: #fff;
    overflow: hidden;
    z-index: 3;
  }
  #toolbar .command{
    cursor: pointer;
    margin-right: 10px;
    opacity: .5;
    transition: opacity .3s;
    font-size: 18px
  }
  #toolbar .command:hover{
    opacity: 1;
    color: #3385ff;
  }
  #contextmenu{
    margin: 0px;
    width: 200px;
    background: white;
    box-shadow: 0px 1px 4px rgba(0,0,0,0.25);
    color: #000;
    font-size: 12px;
    display: none;
  }
  #contextmenu .disable{
    color: rgba(0,0,0,0.25);
  }
  #contextmenu .command{
    height: 12px;
    padding: 8px;
    box-sizing: content-box;
  }
  #contextmenu .command:hover{
    cursor: pointer;
    background: #E6F7FF;
  }
  #contextmenu .command.disable:hover{
    cursor: default;
    background: none;
  }
  #contextmenu span:nth-of-type(1){
    float: left;
  }
  #contextmenu span:nth-of-type(2){
    float: right;
  }
  #detailpannel{
    width: 200px;
    height: 100%;
    position: absolute;
    top: 0;
    right: 0px;
    z-index: 9;
    background: #F7F9FB;
    border: 1px solid #ddd;
    border-bottom: none;
  }
  #detailpannel .pannel-item {
    text-align: left;
    margin-bottom: 10px;
  }
  #detailpannel .pannel{
    display: none
  }
  #detailpannel .block-container{
    font-size: 14px;
    padding: 16px 8px;
    text-align: center;
  }
  #detailpannel .pannel-input {
    width: 132px;
  }
  #detailpannel .pannel-input-min {
    width: 64px;
  }
  #navigator{
    border: 1px solid #ddd;
    border-top: none;
    width: 200px;
    height: 182px;
    position: absolute;
    bottom: 0px;
    right: 0px;
    z-index: 9;
  }
  #navigator #minimap{
    width: 198px;
    height: 130px;
  }
  #navigator #zoom-slider{
    padding: 0 20px;
    height: 22px;
    position: relative;
  }
  #navigator .slider-wrap {
    padding: 0 20px;
  }
  #navigator .slider-wrap .el-slider__runway {
    margin: 8px;
  }
  .text-item {
    display: inline-block;
    width: 90px;
    height: 40px;
    margin-left: 4px;
    border-radius: 2px;
    border: 1px solid rgba(0,0,0,0);
    position: relative;
  }
  .text-item:hover {
    border: 1px solid #ccc;
    cursor: move;
  }
  .text-item div {
    position: absolute;
    top: 50%;
    left: 50%;
    transform: translate(-50%, -50%);
    font-size: 16px;
    font-weight: bolder;
    width: 80px;
    color: #0000009c;
    height: 20px;
    line-height: 20px;
    text-align: center;
    background: #fff;
    border-radius: 4px;
    padding: 2px;
  }
  .line-item {
    display: inline-block;
    position: relative;
    width: 70px;
    height: 40px;
    padding: 4px;
    margin-left: 4px;
    border-radius: 2px;
    border: 1px solid rgba(0,0,0,0);
  }
  .line-hor {
    width: 60px;
    height: 1px;
    background: #9c9c9c;
    position: absolute;
    top: 50%;
    left: 50%;
    transform: translate(-50%, -50%);
  }
  .line-item-ver {
    margin-top: 20px;
    transform: rotate(90deg);
  }
  .line-item:hover {
    cursor: move;
    border: 1px solid #ccc;
  }
  .link-dialog .input-radio b {
    width: 132px;
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
    display: inline-block;
    vertical-align: sub;
  }
  .fade-enter-active, .fade-leave-active {
    transition: opacity .5s;
  }
  .fade-enter, .fade-leave-to /* .fade-leave-active below version 2.1.8 */ {
    opacity: 0;
  }
</style>